import { Injectable } from '@angular/core';
import { AmlEntityType, CreateAmlEntry } from '@core/state/types/aml.types';
import { Observable, tap } from 'rxjs';
import { FirmActions } from '../state/firm/firm.actions';
import { BLService } from './bl.service';

@Injectable({ providedIn: 'root' })
export class AmlService extends BLService {
  private RESOURCE_ENDPOINT = 'aml';

  getAmlApiEmail(): Observable<{ email: string | null }> {
    return this.httpGet<{ email: string }>(`${this.RESOURCE_ENDPOINT}/integration`);
  }

  activateIntegration(data: { email: string; password: string }): Observable<{ email: string }> {
    return this.httpPost<{ email: string }>(`${this.RESOURCE_ENDPOINT}/integration`, data).pipe(
      tap(({ email }) => this.store.dispatch(FirmActions.verifyAmlConnectionSucceeded({ email }))),
    );
  }

  updateActiveIntegrationCredentials(data: { email: string; password: string }): Observable<{ email: string }> {
    return this.httpPut<{ email: string }>(`${this.RESOURCE_ENDPOINT}/integration`, data).pipe(
      tap(({ email }) => this.store.dispatch(FirmActions.verifyAmlConnectionSucceeded({ email }))),
    );
  }

  deactivateIntegration(): Observable<void> {
    return this.httpDelete<void>(`${this.RESOURCE_ENDPOINT}/integration`).pipe(
      tap(() => this.store.dispatch(FirmActions.verifyAmlConnectionSucceeded({ email: null }))),
    );
  }

  createAmlForClient(clientId: number): Observable<AmlEntityType> {
    return this.httpPost<AmlEntityType>(`${this.RESOURCE_ENDPOINT}/${clientId}`, null);
  }

  createManualAmlForClient(clientId: number, data: CreateAmlEntry): Observable<AmlEntityType> {
    return this.httpPost<AmlEntityType>(`${this.RESOURCE_ENDPOINT}/${clientId}/manual`, data);
  }

  attachExistingAmlForClient(clientId: number, amlId: string): Observable<AmlEntityType> {
    return this.httpPost<AmlEntityType>(`${this.RESOURCE_ENDPOINT}/${clientId}/attach`, { amlId });
  }

  loadAmlDataForClient(clientId: number): Observable<AmlEntityType[]> {
    return this.httpGet<AmlEntityType[]>(`${this.RESOURCE_ENDPOINT}/${clientId}`);
  }

  deleteAmlEntity(id: number): Observable<void> {
    return this.httpDelete<void>(`${this.RESOURCE_ENDPOINT}/${id}`);
  }
}
